// @flow
import React from 'react';
import { graphql } from 'gatsby';
import Layout from '../components/Layout';
import Post from '../components/Post';
import Series from '../components/Series';
import NavHeader from '../components/NavHeader';
import SubscribePopup from '../components/SubscribePopup';
import CarbonAd from '../components/CarbonAd';
import FixedScrollContainer from '../components/FixedScrollContainer';

const PostTemplate = ({ data, pageContext }) => {
  const { author, title: siteTitle, subtitle: siteSubtitle, url: siteUrl } = data.site.siteMetadata;
  const { edges } = data.allMarkdownRemark;
  const { slug, prev, next } = pageContext;

  const [slugNode, prevNode, nextNode] = [slug, prev, next].map(
    s => edges.filter(e => e.node.frontmatter.slug === s)[0].node,
  );

  const {
    canonical,
    category,
    date,
    img: imgUrl,
    isSeries,
    isML,
    isWeb,
    title: postTitle,
    description: postDescription,
    twitterEmbed,
  } = slugNode.frontmatter;

  // Simple word count estimation based on content length
  let wordCount = Math.ceil((slugNode.html.length + (data.seriesEnd?.html.length || 0)) / 5);

  const metaDescription = postDescription !== null ? postDescription : siteSubtitle;

  return (
    <>
      <NavHeader />
      <Layout title={`${postTitle} - ${siteTitle}`} description={metaDescription}>
        {isSeries ? (
          <Series htmlEnd={data.seriesEnd.html} series={slugNode} seriesPosts={data.seriesPosts} />
        ) : (
          <Post post={slugNode} prevPost={prevNode} nextPost={nextNode} />
        )}
      </Layout>
    {/*!isSeries && <SubscribePopup postSlug={slug} isML={isML} isWeb={isWeb} />*/}
      <FixedScrollContainer>
    {/*<CarbonAd largeOnly />*/}
      </FixedScrollContainer>
    </>
  );
};

export const Head = ({ data, pageContext }) => {
  const { author, title: siteTitle, subtitle: siteSubtitle, url: siteUrl } = data.site.siteMetadata;
  const { edges } = data.allMarkdownRemark;
  const { slug, prev, next } = pageContext;

  const [slugNode, prevNode, nextNode] = [slug, prev, next].map(
    s => edges.filter(e => e.node.frontmatter.slug === s)[0].node,
  );

  const {
    canonical,
    category,
    date,
    img: imgUrl,
    isSeries,
    isML,
    isWeb,
    title: postTitle,
    description: postDescription,
    twitterEmbed,
  } = slugNode.frontmatter;

  // Simple word count estimation based on content length
  let wordCount = Math.ceil((slugNode.html.length + (data.seriesEnd?.html.length || 0)) / 5);

  const metaDescription = postDescription !== null ? postDescription : siteSubtitle;

  return (
    <>
      <html lang="en" />
      <title>{`${postTitle} - ${siteTitle}`}</title>
      <meta name="description" content={metaDescription} />
      <meta property="og:title" content={`${postTitle} - ${siteTitle}`} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:image" content={siteUrl + author.photoLarge} />
      {canonical && <link rel="canonical" href={canonical} />}
      <meta property="og:type" content="article" />
      <meta property="og:image" content={imgUrl} />
      {twitterEmbed && (
        <script async defer src="https://platform.x.com/widgets.js" charset="utf-8" />
      )}

      <script type="application/ld+json">
        {`{
  "@context": "https://schema.org",
  "@type": "BlogPosting",
  "image": "${imgUrl}",
  "url": "${siteUrl + slug}",
  "headline": "${postTitle}",
  "description": "${postDescription}",
  "wordcount": "${wordCount}",
  "dateCreated": "${date}",
  "datePublished": "${date}",
  "inLanguage": "en-US",
  "mainEntityOfPage": "True",
  "articleBody": "${slugNode.excerpt}",
  "articleSection": "${category}",
  "author": {
    "@type": "Person",
    "name": "${author.name}",
    "url": "${siteUrl}"
  },
  "publisher": {
    "@type": "Organization",
    "name": "${author.name}",
    "url": "${siteUrl}",
    "logo": {
      "@type": "ImageObject",
      "url": "${siteUrl}${author.photoLarge}",
      "width": "1024",
      "height": "1024"
    }
  }
}`}
      </script>
    </>
  );
};

export const fragment = graphql`
  fragment PostFragment on Query {
    site {
      siteMetadata {
        author {
          name
          photoLarge
        }
        url
        subtitle
        title
      }
    }
    allMarkdownRemark(filter: { frontmatter: { slug: { in: [$slug, $prev, $next] } } }) {
      edges {
        node {
          id
          html
          excerpt(pruneLength: 5000)
          fields {
            tagSlugs
          }
          frontmatter {
            canonical
            category
            date
            description
            img
            isSeries
            isML
            isWeb
            slug
            tags
            title
            twitterEmbed
            discussLinkTwitter
            discussLinkHN
            discussLinkReddit
          }
        }
      }
    }
  }
`;

export const query = graphql`
  query PostBySlug($slug: String!, $prev: String, $next: String) {
    ...PostFragment
  }
`;

export default PostTemplate;
